import { render, staticRenderFns } from "./sendDialog.vue?vue&type=template&id=4586e1af&"
import script from "./sendDialog.vue?vue&type=script&lang=js&"
export * from "./sendDialog.vue?vue&type=script&lang=js&"
import style0 from "./sendDialog.vue?vue&type=style&index=0&id=4586e1af&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports